// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const userAuthApi = baseApi.injectEndpoints({
  // reducerPath: "userAuthApi",

  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (user) => {
        return {
          url: "admin/login",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    forgotPassword: builder.mutation({
      query: (user) => {
        return {
          url: "admin/forgot-password",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginUserMutation, useForgotPasswordMutation } = userAuthApi;
